import { useContext } from 'react';
import { WritersContext, IWritersContext } from '../../store/writers.context';

export function useWriters(): IWritersContext {
  const context = useContext(WritersContext);
  if (!context) throw new Error('useWriters mus be used within a WritersProvider');
  return context as IWritersContext;
}
